<template>
  <div id="app" style="min-height:100%">
    <HeaderTop></HeaderTop>
    <Header></Header>
    <keep-alive>
      <!-- v-if="$route.meta.keepAlive" :key="key" -->
      <router-view :key="key"></router-view>
    </keep-alive>
  </div>
</template>
<script>
  export default {
    name: 'app',
    data() {
      return{
          
      }
    },
    components: {},
    computed:{
      key() {
        return this.$route.name ? this.$route.name+ +new Date() : this.$route+ +new Date()
      }
    },
    methods:{},
    mounted() {
    },
    created(){}
  }
</script>
<style lang="less">
  @import 'less/frontend.less';
  // 阿里字体图标设置
  .icon, .iconfont {
    font-family:"iconfont" !important;
    font-size:16px;
    font-style:normal;
    -webkit-font-smoothing: antialiased;
    -webkit-text-stroke-width: 0.2px;
    -moz-osx-font-smoothing: grayscale;
  }

  @media screen and (min-width:1100px) and (max-width:1200px) {
    #app {
      zoom: 0.9;
    }
  }
  @media screen and (min-width:750px) and (max-width:1099px) {
    #app {
      zoom: 0.7;
    }
  }
</style>
